import React from 'react';

const EditPost = () => {
  return (
    <div>
      <h2>Edit Post is Coming </h2>
    </div>
  );
};

export default EditPost;